import {createContext} from "react";


export interface AdditionalSupportContextState {
    showHotel: boolean;
    showParking: boolean;
    showBanquet: boolean;
    banquetLocation: string;
    hotelCount: number;
    parkingCount: number;
    banquetCount: number;
    
    onHotelCountChange: ((count: number) => void) | undefined;
    onParkingCountChange: ((count: number) => void) | undefined;
    onBanquetCountChange: ((count: number) => void) | undefined;
}

export const CreateDefaultAdditionalSupportContextValue = (): AdditionalSupportContextState => {
    return {
        showHotel: true,
        showParking: true,
        showBanquet: true,
        banquetLocation: '',
        hotelCount: 0,
        parkingCount: 0,
        banquetCount: 0,
        onHotelCountChange: undefined,
        onParkingCountChange: undefined,
        onBanquetCountChange: undefined,
    };
}

export const AdditionalSupportContext = createContext<AdditionalSupportContextState>(CreateDefaultAdditionalSupportContextValue());

